/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_Export_HintInputs */

const en_us2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to keep a copy first? Use “Export my data”.`)
};

const pt_br2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer guardar uma cópia antes? Use “Exportar meus dados”.`)
};

const es_419_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres guardar una copia antes? Usa “Exportar mis datos”.`)
};

const pt_pt2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queres guardar uma cópia antes? Usa “Exportar os meus dados”.`)
};

const fr_fr2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu veux d'abord garder une copie ? Utilise « Exporter mes données ».`)
};

const de_de2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willst du vorher eine Kopie behalten? Nutze „Meine Daten exportieren“.`)
};

const it_it2_profile_editors_delete_export_hint = /** @type {(inputs: Profile_Editors_Delete_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi prima tenerne una copia? Usa “Esporta i miei dati”.`)
};

/**
* | output |
* | --- |
* | "Want to keep a copy first? Use “Export my data”." |
*
* @param {Profile_Editors_Delete_Export_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_export_hint = /** @type {((inputs?: Profile_Editors_Delete_Export_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_Export_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_export_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_export_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_export_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_export_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_export_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_export_hint(inputs)
	return en_us2_profile_editors_delete_export_hint(inputs)
});
export { profile_editors_delete_export_hint as "profile-editors.delete_export_hint" }